import React from "react";
import { View, Text } from "react-native";
import { PILL_COLORS } from "../constants";

/**
 * Pill component for displaying exercise type or modifier
 */
export const Pill = ({ label, type = "modifier" }) => {
  const colors = PILL_COLORS[type] || PILL_COLORS.modifier;

  return (
    <View
      style={{
        backgroundColor: colors.background,
        paddingHorizontal: 8,
        paddingVertical: 3,
        borderRadius: 8,
        maxWidth: "100%",
        flexShrink: 1,
        minWidth: 0,
        alignSelf: "flex-start",
      }}
    >
      <Text
        style={{
          fontSize: 11,
          fontWeight: "500",
          color: colors.text,
          flexShrink: 1,
        }}
        numberOfLines={2}
        ellipsizeMode="tail"
      >
        {label}
      </Text>
    </View>
  );
};
